import { media } from 'responsive/media';
import styled, { css } from 'styled-components';

export const StyledInput = styled.input`
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: ${(props) => (props.height ? `${props.height}px` : '39px')};
  border-radius: 10px;
  border: 1px solid #e9e9e9;
  padding: 10px 12px;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  outline: none;
  transition: all 0.3s ease;
  background-color: #ffffff;
  color: #333333;

  &::placeholder {
    color: #999999;
    font-size: 14px;
    font-weight: 400;
    font-family: 'Inter', sans-serif;
  }

  &:focus {
    border-color: #ed7836;
    box-shadow: 0 0 0 2px rgba(237, 120, 54, 0.1);
  }

  &:hover {
    border-color: #ed7836;
  }

  &:disabled {
    background-color: #f5f5f5;
    color: #999999;
    cursor: not-allowed;
    border: 1px solid #e9e9e9 !important;
    transition: none !important;
    &:hover {
      border: 1px solid #e9e9e9 !important;
      transition: none !important;
    }
  }

  &.error {
    border-color: #ff4d4f;
    box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.1);
  }

  /* ========= Responsive ========= */

  ${media.xxlDown(css`
    width: ${({ width }) => (width ? `${width}px` : '100%')};
    height: ${({ height }) => (height ? `${height * 0.9}px` : '36px')};
    border-radius: 8px;

    &::placeholder {
      font-size: 13px;
    }
  `)}

  ${media.xlDown(css`
    height: ${({ height }) => (height ? `${height * 0.8}px` : '32px')};
    border-radius: 8px;
    padding: 8px 10px;
  `)}

  ${media.lgDown(css`
    height: ${({ height }) => (height ? `${height * 0.8}px` : '34px')};
    border-radius: 6px;
    padding: 6px 8px;
  `)}

  ${media.mdDown(css`
    height: ${({ height }) => (height ? `${height * 0.75}px` : '30px')};
    border-radius: 4px;
    padding: 4px 6px;
  `)}
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  /* ========= Responsive ========= */
  ${media.mdDown(css`
    margin-bottom: 12px;
  `)}

  ${media.smDown(css`
    margin-bottom: 8px;
  `)}
`;

export const InputRow = styled.div`
  max-width: 100%;
  display: flex;
  align-items: center;
  gap: ${(props) =>
    props.gapLabelInput ? `${props.gapLabelInput}px` : '16px'};
  width: 100%;

  /* ========= Responsive ========= */

  ${media.lgDown(css`
    align-items: flex-start;
  `)}

  ${media.mdDown(css`
    gap: ${(props) =>
      props.gapLabelInput
        ? `${props.gapLabelInput * 0.95}px`
        : '6px'} !important;
  `)}

  ${media.smDown(css`
    gap: ${(props) =>
      props.gapLabelInput
        ? `${props.gapLabelInput * 0.9}px`
        : '4px'} !important;
  `)}
`;

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  max-width: 100%;
  flex: 1;

  /* ========= Responsive ========= */
  ${media.lgDown(css`
    width: 100%;
  `)}
`;

export const DefaultText = styled.span`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: #595959;
  pointer-events: none;
  user-select: none;

  /* ========= Responsive ========= */
  ${media.xxlDown(css`
    width: ${({ width }) => (width ? `${width * 0.7}px` : '')};
  `)}

  ${media.xlDown(css`
    right: 10px;
  `)}

  ${media.lgDown(css`
    right: 8px;
  `)}

  ${media.mdDown(css`
    right: 6px;
  `)}
`;

export const InputLabel = styled.label`
  font-weight: 400;
  color: #000000;
  min-width: ${(prop) => `${prop.$widthLabel}px` || 'auto'};
  max-width: ${(prop) => `${prop.maxWidthLabel}px` || '100%'};
  text-align: left;
  flex-shrink: 0;

  .required {
    color: red;
    margin-left: 4px;

   
`;

export const ErrorMessage = styled.div`
  color: #ff4d4f;
  margin-left: ${(props) =>
    props.$paddingMessage !== null ? `${props.$paddingMessage}px` : '0'};
  min-height: 0;
  font-size: 12px;
  opacity: ${(props) => (props.$show ? 1 : 0)};
  transition: opacity 0.3s ease;
`;
